import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/app/[lang]/blog/[slug]/EnquireInsights.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/app/[lang]/blog/[slug]/shareButton.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/app/[lang]/blog/[slug]/TableOfContent.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/app/[lang]/browsecourses/[type]/[slug]/Enquiry.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/assets/svg/ArrowRightIcon.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/components/autocomplete/BlogAutocomplete.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/components/BlogCarousel.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/components/LazyLoader.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/components/molecules/Editor.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/components/molecules/index.jsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/lp-frontend/src/components/newsletterForm.jsx");
